<template>
    <div>
        <h6 class="has-text-grey is-uppercase">Lesson Title</h6>
        <div class="mb-6">
            <b-field>
                <b-input size="is-large" v-model="component.title"/>
            </b-field>
        </div>

        <!-- CONTENT -->
        <b-collapse animation="slide">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Content</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <content-blocks :blocks="component.content.content"/>
            </div>

        </b-collapse>

        <b-collapse animation="slide" class="mt-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <b-field label="Description (Internal)" class="mb-5">
                    <b-input type="textarea" size="is-small" v-model="component.description" />
                </b-field>

                <b-field><b-switch v-model="component.content.attributes.minTimeToggle">Require a minimum amount of time spent in lesson.</b-switch></b-field>
                <div class="columns" v-if="component.content.attributes.minTimeToggle">
                    <div class="column is-3 is-offset-1">
                        <b-field message="Minutes (1-360)"><b-input type="number" min="1" max="360" v-model="component.content.attributes.minTime"></b-input></b-field>
                    </div>
                </div>
                <b-field><b-switch v-model="require_approval" true-value="1" false-value="0">Once complete, require additional approval before they can move on.</b-switch></b-field>
                <b-field><b-switch v-model="require_signature" true-value="1" false-value="0">Require a signature agreeing to a condition before completing.</b-switch></b-field>
            </div>
        </b-collapse>
    </div>

</template>

<script>
    import ContentBlocks from "../ContentBlocks.vue";

    export default {
        components: {ContentBlocks},
        props: ['component'],
        data: function() {
            return {
                content: {},
                reqTimeToggle: false,
                reqScoreToggle: false,
                require_min_time: 0,
                require_approval: false,
                require_signature: false
            };
        }
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
